
import showdown from "showdown" 

export default function(o, done){

  var type = 'press'

  var label = o.util.getTranslation(o, type)

  document.title = `Open Memory Box | ${label}`

  var lang = o.store('lang')

  var converter = new showdown.Converter({
    simpleLineBreaks: true,
    openLinksInNewWindow: true,
  })

  o.data.content(o, function(contentData){

    var content = _.find(contentData, {view: type})

    var markdown = content[lang]

    var html = converter.makeHtml(markdown)

    var textDiv =
      $('<div>')
      .css(o.morePagesTextCss)
      .css({
        textTransform: 'none',
      })

    var pressDownloadsDiv =
      $('<div>')
      .css({
        marginBottom: '1rem',
        textTransform: 'uppercase',
        color: o.colors.red,
      })
      .append(
        o.util.getTranslation(o, 'pressDownloads')
      )

    textDiv.append(pressDownloadsDiv)

    if(o.store('pressAccess')){

      var downloadContent = _.find(contentData, {view: 'pressDownload'})
      var downloadMarkdown = downloadContent[lang]
      var downloadHtml = converter.makeHtml(downloadMarkdown)

      var downloadDiv = $('<div>')
      .css({
        marginBottom: '2.1rem',
      })
      .html(downloadHtml)

      textDiv.append(downloadDiv)

    } else {

      var errorLabel =
        o.util.getTranslation(o, 'wrongCode')

      var login = function(){
        if(inputDiv.val().toLowerCase() == 'ombpresslogin'){
          o.store('pressAccess', true)
          o.store('earlyAccess', true)
          errorDiv.html('&nbsp;')
          o.render(o)
        } else {
          errorDiv.html(errorLabel)
        }
      }

      var passwordDiv =
        $('<div>')
        .css({
          marginBottom: '0.2rem',
          textTransform: 'uppercase',
        })
        .append(
          o.util.getTranslation(o, 'password')
        )

      var inputDiv =
        o.component.input(o, true)
        .attr({
          type: 'password',
        })
        .css({
          display: 'block',
          width: '15rem',
          maxWidth: '90%',
          margin: '0 auto',
        })
        .keyup(function(e) {
          if (e.keyCode === 13) {
            login()
          }
        })

      var loginLabel =
        o.util.getTranslation(o, 'login')
    
      var loginDiv =
        o.component.button(o, loginLabel, login)
        .css({
          textTransform: 'uppercase',
        })
        
      var errorDiv =
        $('<div>')
        .css({
          color: o.colors.red,
          textTransform: 'none',
          marginTop: '-0.2rem',
        })
        .html('&nbsp;')

      textDiv.append([
        passwordDiv,
        inputDiv,
        loginDiv,
        errorDiv,
      ])

    }

    textDiv.append(html)

    var div = $('<div>')
    .css(o.mainDivCss)
    .addClass('iphoneNavbarFixTop')
    .addClass('iphoneNavbarFixBottom')  
    .append([

      o.component.menu(o)
      .css({
        flex: '0 0 auto',
        width: '100%',
        zIndex: 1,
      }),

      $('<div>')
      .css({
        flex: '1 1 auto',
      }),

      $('<div>')
      .css({
        flex: '0 1 auto',
        justifyContent: 'center',
        overflowY: 'auto',
        '-webkit-overflow-scrolling': 'touch',
        minHeight: 0,
        zIndex: 1,
      })
      .html(textDiv),

      $('<div>')
      .css({
        flex: '1 1 auto',
      }),

    ])

    done(div)

  })

}



// WEBPACK FOOTER //
// ./src/client/view/frontend/views/press/press.js